<template>
  <LayoutOneColumn>
    <div class="flex flex-col gap-4">
      <!-- sm:px-1 for vsisible focus styles -->
      <div
        class="flex gap-2 px-2 overflow-x-scroll max-w-full py-1 md:flex-wrap"
      >
        <SidebarMenuItem
          v-for="section in menu"
          :key="section.id"
          :item="section"
          theme="white"
        />
      </div>
      <EventsItemPageContent />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { EventType } from '~/models/events'
import { useEvents } from '~/stores/events'

const eventsStore = useEvents()
const menu = eventsStore.getSectionList(EventType.Course)
const { $hhCareer } = useNuxtApp()

onMounted(() => {
  sendHHCareerEvent()
})

function sendHHCareerEvent(): void {
  if (!eventsStore.event) {
    return
  }

  const transactionId = $hhCareer.extractTransactionId()
  if (!transactionId) {
    return
  }

  const offerId = eventsStore.event.id
  const offerName = eventsStore.event.name

  setTimeout(async () => {
    try {
      $hhCareer.saveOfferTransactionId(offerId, transactionId)
      await $hhCareer.sendRedirectEvent(offerId, offerName)
    } catch (error: any) {
      useLogError(error)
    }
  }, 0)
}
</script>
